"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyVehicle = void 0;
var Driver_1 = require("./Driver");
function makeEmptyVehicle() {
    return {
        brandId: '',
        modelId: '',
        modelGroupId: '',
        type: '',
        use: '',
        modelYear: 0,
        value: 0,
        passengersQty: 0,
        driver: Driver_1.makeEmptyDriver(),
        isNewCar: false,
        licensePlate: '',
        serialChassis: '',
        serialMotor: '',
        luxuryTransportationService: false,
    };
}
exports.makeEmptyVehicle = makeEmptyVehicle;
//# sourceMappingURL=Vehicle.js.map